import React, { Ref, forwardRef, useEffect, useState, ReactNode } from "react"
import {
  Wrapper,
  Content,
  MenuWrapper,
  LogoWrapper,
  Logo,
  Navigation,
} from "./header.style"
import { Link } from "gatsby"
import { up, down, between, only } from "styled-breakpoints"
import { useBreakpoint } from "styled-breakpoints/react-styled"
import MobileNav from "./mobileNav"
import MenuItem from "./menuItem"
import { GatsbyImage, getImage } from "gatsby-plugin-image"

type MainMenuItem = {
  title: string
  key: string
  url: string
  blank: boolean
  outlined: boolean
  border?: string
  external: boolean
}

type Props = {
  actualSite?: string
  children?: ReactNode
  items: MainMenuItem[]
  logoUrl: {
    external: boolean
    url: string
    image: any
  }
}

const Header = forwardRef(
  ({ actualSite, children, items, logoUrl }: Props, ref) => {
    const [scrollY, setScrollY] = useState(0)
    const logoImage = getImage(logoUrl.image?.gatsbyImage)

    useEffect(() => {
      const handleScroll = () => {
        if (window.scrollY < 100) {
          setScrollY(0)
        } else if (window.scrollY > 200) {
          setScrollY(window.scrollY)
        }
      }

      window.addEventListener("scroll", handleScroll)

      return function unMount() {
        window.removeEventListener("scroll", handleScroll)
      }
    }, [])

    return (
      <Navigation ref={ref}>
        <Wrapper scroll={scrollY}>
          <Content>
            <LogoWrapper>
              {!logoUrl.external && (
                <Link to={logoUrl.url}>
                  {logoImage && (
                    <Logo
                      scroll={scrollY}
                      image={logoImage}
                      alt={logoUrl.image.altText}
                    />
                  )}
                </Link>
              )}
              {logoUrl.external && (
                <a href={logoUrl.url}>
                  {logoImage && (
                    <Logo
                      scroll={scrollY}
                      image={logoImage}
                      alt={logoUrl.image.altText}
                    />
                  )}
                </a>
              )}
            </LogoWrapper>
            <MenuWrapper>
              {items.map((menuItem, key) => {
                return (
                  <MenuItem
                    active={actualSite == menuItem.key}
                    key={key}
                    menuItem={menuItem}
                    scrollY={scrollY}
                  />
                )
              })}
            </MenuWrapper>
            <MobileNav items={items} logoUrl={logoUrl} />
          </Content>
        </Wrapper>
        {children}
      </Navigation>
    )
  }
)

export default Header
